import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="px-4 md:px-6 max-w-[1200px] mx-auto py-12" aria-label="漫画分类导航">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">漫画分类</h2>
        <p className="text-sm text-foreground-500 mt-2">探索你喜欢的漫画类型，发现更多精彩作品</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-3 p-5 bg-background-100 rounded-xl hover:bg-primary-50 hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
          >
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors duration-300 whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}